import React, { forwardRef, useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $getSelection, COMMAND_PRIORITY_EDITOR, SELECTION_CHANGE_COMMAND } from 'lexical';
import type { BeautifulMentionComponentProps } from 'lexical-beautiful-mentions';
import { twMerge } from 'tailwind-merge';
import type { CustomMentionNode } from '@soundxyz/utils/lexical/ContentLexicalStateV1';

export const MentionNode = forwardRef<
  HTMLDivElement,
  BeautifulMentionComponentProps<CustomMentionNode['data']>
>(({ trigger: _t, value, children: _c, data, className, ...rest }, ref) => {
  const [editor] = useLexicalComposerContext();
  const [selected, setSelected] = React.useState(false);

  useEffect(() => {
    return editor.registerCommand(
      SELECTION_CHANGE_COMMAND,
      (_payload, _editor) => {
        const selection = $getSelection();
        const nodes = selection?.getNodes();
        let shouldSelect = false;
        for (const node of nodes ?? []) {
          if (node.__type === 'custom-beautifulMention' && node.__data.key === data?.key) {
            shouldSelect = true;
          }
        }
        setSelected(shouldSelect);
        return false;
      },
      COMMAND_PRIORITY_EDITOR,
    );
  }, [editor, data]);
  return (
    <span
      ref={ref}
      title={value}
      className={twMerge(
        'rounded mx-0 cursor-pointer select-none px-0 font-medium text-fuchsia500',
        selected && '-mx-1 rounded-sm bg-fuchsia500/20 px-1 outline-none',
        className,
      )}
      {...rest}
    >
      {value}
    </span>
  );
});

MentionNode.displayName = 'MentionNode';
